import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import SelectBox from "../../components/shared/fields/SelectBox ";
import Button from "../../components/shared/buttons/button";
import useTranslator from "../../hooks/useTranslator";
import { useCreatePastingPackingWasteMutation, useGetPastingPackingWasteQuery } from "./mixingApi";

const PackingWasteModal = ({ show, setShow, batchCode , waste_type = 'packing_waste' }) => {
  const { _t } = useTranslator();

  const SHIFT_OPTIONS = [
    { value: "morning", label: _t("morning", "Morning") },
    { value: "evening", label: _t("evening", "Evening") },
  ];

  const [formData, setFormData] = useState({
    batch_code:   "",
    shift:        "morning",
    weight_in_kg: "",
    waste_type : waste_type
  });

  const [createPastingPackingWaste, { isLoading: isCreating }] = useCreatePastingPackingWasteMutation();

  // Fetch existing records to prefill on shift change
  const { data: existingWaste } = useGetPastingPackingWasteQuery(
    { 
      batch_code: batchCode ,
      waste_type : waste_type
    },
    { skip: !show || !batchCode }
  );

  // Reset on open
  useEffect(() => {
    if (show) {
      setFormData({
        batch_code:   batchCode ? String(batchCode) : "",
        shift:        "morning",
        weight_in_kg: "",
        waste_type : waste_type
      });
    }
  }, [show, batchCode]);

  // Prefill weight_in_kg when shift changes
  useEffect(() => {
    if (!existingWaste?.data) return;
    const record = existingWaste.data.find((w) => w.shift === formData.shift);
    setFormData((p) => ({
      ...p,
      weight_in_kg: record ? String(parseFloat(record.weight_in_kg) || 0) : "",
    }));
  }, [formData.shift, existingWaste]);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating) return;
    try {
      await createPastingPackingWaste({
        batch_code:   formData.batch_code,
        shift:        formData.shift,
        weight_in_kg: parseFloat(formData.weight_in_kg) || 0,
        waste_type : waste_type
      }).unwrap();
      handleClose();
    } catch (err) {
      console.error("Error saving packing waste:", err);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("add_packing_waste", "Add Packing Waste")}
    >
      <Row>
        <Col lg={12}>
          <InputWithLabel
            label={_t("batch_code", "Batch Code")}
            type="text"
            name="batch_code"
            value={formData.batch_code}
            disabled={true}
          />
        </Col>
        <Col lg={12}>
          <SelectBox
            label={_t("shift", "Shift")}
            name="shift"
            value={formData.shift}
            onChange={handleChange}
            options={SHIFT_OPTIONS}
          />
        </Col>
        <Col lg={12}>
          <InputWithLabel
            label={_t("waste_kg", "Waste KG")}
            type="number"
            name="weight_in_kg"
            value={formData.weight_in_kg}
            onChange={handleChange}
            placeholder="0"
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default PackingWasteModal;
